import { Outlet } from 'react-router'
import { AppName } from './environment'
import { useScreenTitle } from './useScreenTitle'

/** Centred single-column layout for Login, Two-factor, Enrol, Forgot/Reset/Change password. */
export function AuthLayout() {
  useScreenTitle()
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-10">
      <main id="content" className="w-full max-w-sm">
        <p className="mb-6 flex items-center justify-center text-base font-semibold">
          <AppName className="flex items-center" />
        </p>
        <Outlet />
      </main>
    </div>
  )
}
